import CustomeSelectComponent from '../common/CustomeSelectComponent'

export default function StationDropdown({stationCoordenates, handleSelectStationCoordenate, selectStationSearchValue}) {
    return (
        <div style={{ 'display': 'flex', "marginLeft": "10px", marginTop: "10px" }}>
            <div style={{ 'width': '80%'}}>
                <CustomeSelectComponent
                    coordenates={stationCoordenates}
                    handleSelectCoordenate={handleSelectStationCoordenate}
                    selectedValueUp={selectStationSearchValue}
                    placeHolder="Select a station"
                />
            </div>
        </div>
    )
} 